(function () {
  function fillTEBox() {
    var bss = window.BSS_B2B;
    var translations = bss && bss.te && bss.te.teTranslations;
    if (!translations) return;

    var wrappers = document.querySelectorAll(".bss-b2b-tax-ex-wrapper");
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var select = wrapper.querySelector(".bss-b2b-vat-selected");
      wrapper.setAttribute("show-wrapper", select ? select.value : "0");

      if (select && !select.getAttribute("data-bss-te-bound")) {
        select.setAttribute("data-bss-te-bound", "1");
        select.addEventListener("change", function () {
          var box = this.closest(".bss-b2b-tax-ex-wrapper");
          if (box) box.setAttribute("show-wrapper", this.value);
        });
      }

      var map = {
        ".bss-b2b-translation-vat-form_header_text": "form_header_text",
        ".bss-b2b-translation-vat-form_subtitle_text": "form_subtitle_text",
        ".bss-b2b-translation-vat-form_success_message": "form_success_message",
        ".bss-b2b-translation-vat-form_success_message_uk": "form_success_message_uk",
        ".bss-b2b-translation-vat-form_error_message": "form_error_message",
        ".bss-b2b-translation-vat-form_error_message_uk": "form_error_message_uk",
        ".bss-b2b-translation-vat-form_validate_country_code_message": "form_validate_country_code_message"
      };

      for (var selector in map) {
        var el = wrapper.querySelector(selector);
        if (el) el.innerText = translations[map[selector]] || "";
      }
    }
  }

  var timer = setInterval(fillTEBox, 300);
  setTimeout(function () { clearInterval(timer); }, 10000);
})();